// extracted by mini-css-extract-plugin
export var container = "header-service-menu-module--container--Br4Kt";
export var logoutButton = "header-service-menu-module--logoutButton--ZqqNO";
export var menuContainer = "header-service-menu-module--menuContainer--sfTIU";